import React, { useEffect, useState } from 'react'

import { useIntersection, useWindowSize } from 'shared/hooks'

import classes from './Partnership.module.scss'
import { Slider } from './Slider/Slider'

export const Partnership = (): JSX.Element => {
  const [, entry] = useIntersection({})
  const [, setWidth] = useState('')
  const { width } = useWindowSize()

  useEffect(() => {
    const width = entry?.isIntersecting ? `${document.body.offsetWidth}px` : ''

    setWidth(width)
  }, [entry])

  return (
    <div className="container reveal-from-bottom-medium">
      <div className="row row_overflow">
        <div className="col-xs-12">
          <h2 className={`${classes.title}`}>
            Мы сотрудничаем
            <br /> с лучшими специалистами
            <br /> в индустрии
          </h2>
        </div>

        <div className={`col-xs-12 ${classes.content}`}>
          <h2
            className={`${classes.title_desktop} reveal-from-bottom-medium`}
            data-reveal-delay={10}
          >
            С нами
            {width <= 300 ? <br /> : ''} сотрудничают
            {width <= 300 ? <br /> : ''} лучшие
          </h2>

          <Slider />
        </div>
      </div>
    </div>
  )
}
